module.exports = __webpack_public_path__ + "img/art_banner.dd394f97.png";